import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'antd/dist/antd.css';
import './styles/index.scss';
import App from './App';
import { enableMapSet } from 'immer';
import { BrowserRouter as Router } from 'react-router-dom';

const tracePropagationTargets = ['localhost'];
if (import.meta.env.REACT_APP_API_URL) {
    tracePropagationTargets.push(import.meta.env.REACT_APP_API_URL);
}

Sentry.init({
    dsn:
        'https://e8169a5b2ff6eba2d48e690bdb224181@o4506061906378752.ingest.sentry.io/4506061985349632',
    environment: import.meta.env.REACT_APP_ENV,
    release: import.meta.env.REACT_APP_RELEASE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

enableMapSet();

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container element not found');
}

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
    </React.StrictMode>
);
